const formatNum = require('./formatNum');

module.exports = (v) => formatNum(v, 4, '.', ' ');
